import { render, staticRenderFns } from "./SpinnerCustom.vue?vue&type=template&id=607af1ea"
import script from "./SpinnerCustom.vue?vue&type=script&lang=js"
export * from "./SpinnerCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607af1ea')) {
      api.createRecord('607af1ea', component.options)
    } else {
      api.reload('607af1ea', component.options)
    }
    module.hot.accept("./SpinnerCustom.vue?vue&type=template&id=607af1ea", function () {
      api.rerender('607af1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SpinnerCustom.vue"
export default component.exports